import { e as events } from "../../../chunks/events.js";
const load = ({ url }) => {
  const eventIdParam = url.searchParams.get("eventId");
  const eventSeriesParam = url.searchParams.get("eventSeries");
  let selectedEvent = null;
  if (eventIdParam) {
    const eventId = parseInt(eventIdParam, 10);
    selectedEvent = events.find((e) => e.eventId === eventId) ?? null;
  } else if (eventSeriesParam) {
    const currentDateString = (/* @__PURE__ */ new Date()).toLocaleString("en-US", {
      timeZone: "America/Los_Angeles"
    });
    const currentDate = new Date(currentDateString);
    const upcomingEventsInSeries = events.filter((e) => {
      const eventEndDate = new Date(e.tmpEventEndDate);
      return e.eventSeriesKey === eventSeriesParam && eventEndDate >= currentDate;
    }).sort((a, b) => {
      const aStartDate = new Date(a.tmpEventStartDate);
      const bStartDate = new Date(b.tmpEventStartDate);
      return aStartDate.getTime() - bStartDate.getTime();
    });
    selectedEvent = upcomingEventsInSeries[0] ?? null;
  }
  return {
    event: selectedEvent,
    showUpcoming: !eventIdParam && !eventSeriesParam
  };
};
export {
  load
};
